(function () {
  'use strict';

  angular.module('fasttrack', []);

  angular.module('fasttrack').controller('FasttrackController', ['$timeout', '$window', '$scope', 'ext', 'util', fasttrackController]);

  function fasttrackController($timeout, $window, $scope, ext, util) {
    var vm = this;
    setInitialView();
    ext.getTeam(vm);
    vm.eventID = util.getEventID();

    vm.openModal = function (modal) {
      util.openModal(modal, vm);
    };

    vm.closeModal = function () {
      util.closeModal(vm);
    };

    vm.clearInput = function (event) {
      util.clearInput(event, vm);
    };

    vm.searchForTeamMember = function (value, i) {
      util.searchForTeamMember(value, i, vm);
    };

    vm.searchForTeamMemberToShare = function (value) {
      util.searchForTeamMemberToShare(value, vm);
    };

    vm.resetInput = function (event) {
      util.resetInput(event, vm);
    };

    vm.checkCreateTeamValidation = function () {
      util.checkCreateTeamValidation(vm);
    };

    vm.submitCreateTeam = function () {
      util.submitCreateTeam(vm);
    };

    vm.shareWithTeam = function () {
      util.shareWithTeam(vm);
    };

    vm.showMore = function () {
      util.showMore(vm);
    };

    vm.registerTeam = function () {
      if (vm.registrationInProcess === false) {
        ext.trueSubmitCreateTeam(vm);
      }
    };

    vm.submitCreateTeamNotFull = function () {
      ext.trueSubmitCreateTeam(vm);
    };

    vm.closeModalInModal = function () {
      util.closeModalInModal(vm);
    };

    vm.trueSubmitCreateTeam = ext.trueSubmitCreateTeam;

    vm.submitPutTeam = function () {
      ext.submitPutTeam(vm);
    };

    vm.showMoreTeam = function (event, id, list) {
      util.showMoreTeam(event, id, list, vm);
    };

    vm.seeMnthlyAcct = function (id, teamName) {
      util.seeMnthlyAcct(id, teamName, vm);
    };

    vm.seeMain = function () {
      util.seeMain(vm);
    };

    vm.accountabilityMonths = [];

    vm.submitAccountability = function (e) {
      util.gatherAccountability(e, vm);
    };

    vm.updateSharing = function (e) {
      if (vm.updateInProcess === false) {
        util.gatherSharing(e, vm);
      }
    };

    vm.captureReturn = function (e, value) {
      util.captureReturn(e, value, vm);
    };

    vm.setTabActive = function (tabname) {
      util.setTabActive(tabname, vm);
    };

    vm.myOrgTab = function () {
      util.myOrgTab(vm);
    };

    vm.checkAndShareWithMyEnroller = function () {
      util.checkAndShareWithMyEnroller(vm.enrollerPhoneNumber, vm);
    };

    vm.enrollerInList = false;

    vm.checkForEnrollerInList = function () {
      util.checkForEnrollerInList(vm);
    };

    vm.enableUpdate = function () {
      util.enableUpdate(vm);
    };

    vm.scrollToTabs = util.scrollToTabs;
    vm.playVideo = ext.playVideo;
    vm.teamSubmissionSuccess = false;

    vm.sortTableBy = function (sortValue) {
      // console.log('on change called', sortValue);
      util.sortTheTable(sortValue, vm);
    };

    vm.badges = {
      1: 'https://cdnus.melaleuca.com/Images/BusinessCenter/Landing_Page/fast-track/2020/icon-swimupsuite.svg',
      '1alt': 'swim up suite',
      2: 'https://cdnus.melaleuca.com/Images/BusinessCenter/Landing_Page/fast-track/2020/icon_1of4.png',
      '2alt': '1 of 4 receptions earned',
      3: 'https://cdnus.melaleuca.com/Images/BusinessCenter/Landing_Page/fast-track/2020/icon_2of4.png',
      '3alt': '2 of 4 receptions earned',
      4: 'https://cdnus.melaleuca.com/Images/BusinessCenter/Landing_Page/fast-track/2020/icon_3of4.png',
      '4alt': '3 of 4 receptions earned',
      5: 'https://cdnus.melaleuca.com/Images/BusinessCenter/Landing_Page/fast-track/2020/icon_Reception_Earned.png',
      '5alt': 'Reception Earned'
    };

    vm.setCurrentPage = function (currentPage) {
      vm.currentPage = currentPage;
    };

    vm.testCustomer = $window.PageClientData.IsTestCustomer === 'True' ? '_TestCustomers' : ''; // track the checkbox on the create team modal

    $scope.$watch('ft.createTeamCheckbox', function (newValue, oldValue) {
      if (newValue) {
        trackAction({
          id: 313,
          eL: vm.labels.createTeamUnderstand
        });
      }
    }); // track the goal radio button on create team modal

    $scope.$watch('ft.teamGoalInput.value', function (newValue, oldValue) {
      if (newValue !== oldValue) {
        var id = newValue == '8' ? 340 : 341;
        var eL = newValue == '8' ? vm.labels['20PointsLabel'] : vm.labels['12PointLabel'];
        console.log({
          id: id,
          eL: eL
        });
        trackAction({
          id: id,
          eL: eL
        });
      }
    });

    vm.setCurrentPageByOne = function (amnt) {
      if (amnt + vm.currentPage >= vm.paginationArr.length) {
        vm.currentPage = 0;
      } else if (amnt + vm.currentPage < 0) {
        vm.currentPage = vm.paginationArr.length - 1;
      } else {
        vm.currentPage = vm.currentPage + amnt;
      }
    };

    vm.showAll = function () {
      vm.showAllLoading = true;
      $timeout(function () {
        vm.currentPage = 0;
        vm.pageSize = vm.leaderboard.length;
        vm.showPagination = false;
      }, 2);
    };

    function setInitialView() {
      // variables for setting intial view
      vm.loading = true;
      vm.global = $window.ftg;
      vm.mainView = '/BusinessCenter/PrintContent/fast-track-main'; // vm.accountabilityView = '/BusinessCenter/PrintContent/fast-track-monthly-accountability';

      vm.accountabilityView = '/BusinessCenter/PrintContent/fast-track-accountability '; // vm.currentView = `${vm.global.cdn}html/business-center/landing-pages/fast-track/monthly-accountability.html`;
      // this value controls the rewards column

      vm.showRewards = vm.global.showRewards; // this value controls the months for which event is run

      vm.eventMonths = vm.global.eventMonths; // this value controls if goal information is shown
      //Some comment--

      vm.showGoals = vm.global.showGoals;
      vm.dateFormatConfig = vm.global.dateFormatConfig;
      vm.enrollerPhoneNumber = vm.global.enrollerPhoneNumber;
      console.log('the enroller ph.:', vm.enrollerPhoneNumber);
      vm.hasEnroller = false;
      vm.currentView = vm.mainView;
      vm.onFinalTeam = false;
      vm.checkingInitialStatus = true;
      vm.labels = $window.labels;
      vm.culture = $window.PageClientData.UICulture;
      vm.modalIsOpen = false;
      vm.teamSubmitted = false;
      vm.teamHasBeenCreated = false;
      vm.youHaveBeenAdded = false;
      vm.submitError = '';
      vm.teamLeader = false;
      vm.notOnTeam = false;
      vm.leaderBoardActive = true;
      vm.tabLeaderBoardActive = false; // vm.tabMyTeamActive = true;

      vm.tabMyActivityActive = true;
      vm.tabMyOrgActive = false;
      vm.broadcast = $window.fastTrackBroadcast;
      vm.teamAccountabilitySubmitting = false;
      vm.registrationIsOpen = $window.ftg.registrationIsOpen;
      vm.adjustedCulture = util.adjustCulture(vm.culture);
      vm.showAllLoading = false;
      vm.customerID = $window.PageClientData.Id;
      vm.leaderboard = [];
      vm.myOrgLeaderboard = [];
      vm.selectedToUnShare = true;
      vm.searchingForEnroller = false;
      vm.shareWithMyEnroller = {
        selected: ''
      };
      vm.registrationInProcess = false;
      vm.updateInProcess = false;

      if (vm.culture != 'es-MX') {
        vm.topTeamNum = 10;
      } else {
        vm.topTeamNum = 8;
      }

      vm.showPagination = true;
      vm.currentPage = 0;
      vm.pageSize = 200;
      vm.rowSize = 10; // variables for setting initial view in modals

      vm.modals = {
        createTeam: false,
        putMeOnTeam: false,
        success: false,
        shareSuccess: false,
        alert: false,
        shareWithTeam: false,
        updateSuccess: false
      };
      vm.teamGoalInput = {
        value: ''
      };
      vm.createTeamInvalid = true;
      vm.teamNotFull = false;
      vm.teamSubmitting = false;
      vm.teamSubmittingFewer = false;
      vm.isMyActivityDetail = false;
      vm.isAllActivityDetail = false;
      vm.isMySharingList = false;
      vm.potentialMembers = new Array(vm.global.potentialTeamMembers).fill(1).map(function () {
        return {
          value: '',
          status_loading: '',
          status_correct: '',
          status_error: '',
          errorMessage: '',
          result_name: '',
          result_status: '',
          result_status_sortOrder: 0
        };
      });
      vm.potentialShareMember = new Object({
        value: '',
        status_loading: '',
        status_correct: '',
        status_error: '',
        errorMessage: '',
        result_name: '',
        result_status: ''
      });
      vm.foundMembers = [1, 2, 3, 4, 5].map(function () {
        return {
          value: ''
        };
      });
      vm.memberID = $window.PageClientData.Id;
      vm.mustKnowItems = [{
        id: 'frank',
        imagePath: 'Images/BusinessCenter/Landing_Page/fast-track/thumb-frank.jpg',
        docPath: "PDF/BusinessCenter/".concat(vm.adjustedCulture, "/fasttrack-frank-message-").concat(vm.culture, ".pdf")
      }];
      vm.tipsItems = [{
        id: 'contact-list',
        imagePath: 'Images/BusinessCenter/Landing_Page/fast-track/thumb-contact-list.jpg',
        videoId: 'video5'
      }, {
        id: 'cassidy-megan',
        imagePath: 'Images/BusinessCenter/Landing_Page/fast-track/thumb-cassidy-megan.jpg',
        videoId: 'video4'
      }, {
        id: 'broadcast',
        imagePath: 'Images/BusinessCenter/Landing_Page/fast-track/thumb-broadcast.jpg',
        videoId: 'video3'
      }, {
        id: 'intro',
        imagePath: 'Images/BusinessCenter/Landing_Page/fast-track/thumb-intro.jpg',
        videoId: 'video2'
      }];
    }
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  // Factory ext for retreiving or sending data externally
  // ===========================================

  angular.module('fasttrack').factory('ext', ['$http', 'util', '$timeout', '$window', extFactory]);
  var firstload = true;

  function extFactory($http, util, $timeout, $window) {
    return {
      // determine if customer is already on a team and respond accordingly
      getTeam: function getTeam(scope) {
        var _this = this;

        $http.get("/externalservices/api/teams/getteam?memberID=".concat(scope.memberID)) // .get(`https://ezmock.herokuapp.com/api/5cc4ba994b08f90015964df2`)
        .success(function (r) {
          scope.loading = false; // check to see if they have an EventID from a team that matches eventID

          var _team = r.filter(function (obj) {
            return obj.EventID === scope.eventID;
          });

          if (r.length === 0 || _team.length === 0) {
            // they have not created a team or been added to a team
            if (scope.registrationIsOpen) {
              scope.notOnTeam = true;
              return;
            } else {
              scope.registrationIsClosed = true;
            }
          } else {
            // check to see if they are team leader
            if (_team.some(function (obj) {
              return obj.TeamLeadID == scope.memberID;
            })) {
              scope.teamLeader = true;
              scope.team = _team.filter(function (obj) {
                return obj.TeamLeadID == scope.memberID;
              })[0];
            } else {
              // assign the first team returned that is not an orphan team
              scope.team = _team.filter(function (obj) {
                return obj.TeamID != 1 && obj.TeamID != 2;
              })[0];
            }

            _this.getTeamInfo(scope.team.TeamID, scope); // hide buttons to add to team


            scope.notOnTeam = false; // show tabs

            scope.onFinalTeam = true; // populate the leaderboard

            _this.getTeamSharing(scope.memberID, scope.team.TeamID, scope);

            _this.getLeaderboard(scope);

            if (scope.enrollerPhoneNumber) {
              _this.getEnrollerID(scope.enrollerPhoneNumber, scope);
            } // console.log('my team is:', scope.team);

          }
        }).error(function (e) {// console.log(e);
        });
      },
      // This returns data for the team dashboard
      getTeamInfo: function getTeamInfo(id, scope) {
        var that = this;
        $http.get("/ExternalServices/API/Report/GetDynamicData?identifier=TeamEventData_TeamData".concat(scope.testCustomer, "&parameters[0][Key]=TeamID&parameters[0][Value]=").concat(id)).success(function (r) {
          scope.myTeam = util.createTeamWithData(r, scope); // console.log('myTeam',scope.myTeam);
          // if (scope.teamLeader) {

          that.getMyActivityDetail(scope.team.TeamID, scope);
          that.getAccountabilityTeam(scope.myTeam.teamInfo.ID, scope);
          that.getSharingTeamActivityDetail(scope.memberID, scope); // }
        }).error(function (e) {
          console.log(e);
        });
      },
      //This returns data for the 'I am sharing' dashboard
      getTeamSharing: function getTeamSharing(memberId, teamId, scope) {
        console.log('getteamsharing:', teamId, memberId);
        $http.get("/ExternalServices/Api/Teams/GetTeamSharingSubscriptions?memberID=".concat(memberId, "&teamID=").concat(teamId)).success(function (r) {
          scope.isMySharingList = true;
          scope.mySharingList = r;
          console.log('The I am sharing:', r);
        }).error(function (e) {
          console.log(e);
        });
      },
      // This returns data for the myActivity detail
      getMyActivityDetail: function getMyActivityDetail(id, scope) {
        $http.get("/ExternalServices/API/Report/GetDynamicData?identifier=TeamEventData_MyActivityDetail".concat(scope.testCustomer, "&parameters[0][Key]=CustomerID&parameters[0][Value]=").concat(id)) //.get(`https://ezmock.herokuapp.com/api/60021c468a0bc9001546a4e5`)
        .success(function (r) {
          scope.isMyActivityDetail = true;
          console.log('success');

          if (r.length) {
            scope.myActivityDetail = r; //console.log('The myactivity detail:', scope.myActivityDetail);
          } else {
            console.log('No data returned for this customer.');
            scope.myActivityDetail = [{
              ActivityType: 'Enrollments',
              Month1Activity: 0,
              Month2Activity: 0,
              Month3Activity: 0,
              Month4Activity: 0,
              Month5Activity: 0,
              QualityTotalActivity: 0
            }, {
              ActivityType: 'PersonallyDevelopedLeadership',
              Month1Activity: 0,
              Month2Activity: 0,
              Month3Activity: 0,
              Month4Activity: 0,
              Month5Activity: 0,
              QualityTotalActivity: 0
            }];
          }
        }).error(function (e) {
          console.log(e);
        });
      },
      // This returns data for the entire sharing team
      getSharingTeamActivityDetail: function getSharingTeamActivityDetail(id, scope) {
        $http.get("/ExternalServices/API/Report/GetDynamicData?identifier=TeamEventData_SharedActivityDetail".concat(scope.testCustomer, "&parameters[0][Key]=CustomerID&parameters[0][Value]=").concat(id)) // .get(`https://ezmock.herokuapp.com/api/603822af1321dc0015fad954`)
        .success(function (r) {
          scope.isAllActivityDetail = true;
          console.log('success');

          if (r.length) {
            scope.allActivityDetail = r.reduce(function (acc, cur, i) {
              if (i === 1) {
                var temp1 = [{
                  //Total: cur.QualityTotalActivity + acc.QualityTotalActivity,
                  TeamID: cur.TeamID,
                  Total: cur.Total,
                  prevEnrollment: cur.prevEnrollment,
                  SharedCustomerName: cur.SharedCustomerName,
                  Enrollments: acc,
                  Leadership: cur
                }];
                return temp1;
              } else if (i % 2 === 0) {
                var temp2 = {
                  TeamID: cur.TeamID,
                  Total: cur.Total,
                  prevEnrollment: cur.prevEnrollment,
                  SharedCustomerName: cur.SharedCustomerName,
                  Enrollments: cur
                };
                acc.push(temp2);
                return acc;
              } else {
                if (acc[acc.length - 1]) {
                  acc[acc.length - 1].Leadership = cur;
                  return acc;
                }

                return acc;
              }
            });
            console.log('The all activity:', scope.allActivityDetail);
          } else {
            console.log('No data returned for the team customer.');
          }
        }).error(function (e) {
          console.log(e);
        });
      },
      //get the enroller customer id
      getEnrollerID: function getEnrollerID(value, scope) {
        $http.get('/ExternalServices/API/Organization/SearchForCustomer', {
          params: {
            searchValue: value
          }
        }).success(function (r) {
          if (r.length === 1) {
            scope.hasEnroller = true;
            scope.enrollerCustId = r[0].CustomerId; //console.log('the enroller id', scope.enrollerCustId);
          } else {
            console.log('No enroller with this ph.number');
          }
        }).error(function (e) {
          console.log('the errored output in looking enrollerId:', e);
          return e;
        });
      },
      // function used in searching team member
      searchForTeamMemberToShare: function searchForTeamMemberToShare(value, scope) {
        console.log('searching initiate');
        scope.potentialShareMember.status_loading = true;
        scope.potentialShareMember.status_correct = '';
        scope.potentialShareMember.status_error = '';
        scope.potentialShareMember.errorMessage = '';
        scope.potentialShareMember.result_name = '';
        scope.potentialShareMember.result_status = '';
        $http.get('/ExternalServices/API/Organization/SearchForCustomer', {
          params: {
            searchValue: value
          }
        }).success(function (r) {
          scope.potentialShareMember.status_loading = false; // scope.foundMembers[i].value = value;

          if (r.length === 1) {
            console.log(r);

            var _util$checkStatusRule = util.checkStatusRules(r[0], scope),
                _util$checkStatusRule2 = _slicedToArray(_util$checkStatusRule, 2),
                valid = _util$checkStatusRule2[0],
                errorMessage = _util$checkStatusRule2[1];

            if (valid) {
              scope.potentialShareMember.status_correct = true;
            } else {
              scope.potentialShareMember.status_error = true;
              scope.potentialShareMember.errorMessage = errorMessage;
            }

            scope.potentialShareMember.result_name = r[0].GreetingName;
            scope.potentialShareMember.memberID = r[0].CustomerId;
          } else {
            scope.potentialShareMember.status_error = true;
            scope.potentialShareMember.errorMessage = scope.labels.errorMessages.notFound;
          } // util.checkCreateTeamValidation(scope);

        }).error(function (e) {
          scope.potentialShareMember.status_loading = false;
          scope.potentialShareMember.status_error = true;

          if (e.length > 50) {
            scope.potentialShareMember.errorMessage = scope.labels.errorMessages.somethingWentWrong;
          } else {
            scope.potentialShareMember.errorMessage = e.replace(/"/g, '');
          }
        });
      },
      // function used in craete team modal
      searchForTeamMember: function searchForTeamMember(value, i, scope) {
        scope.potentialMembers[i].status_loading = true;
        scope.potentialMembers[i].status_correct = '';
        scope.potentialMembers[i].status_error = '';
        scope.potentialMembers[i].errorMessage = '';
        scope.potentialMembers[i].result_name = '';
        scope.potentialMembers[i].result_status = '';
        $http.get('/ExternalServices/API/Organization/SearchForCustomer', {
          params: {
            searchValue: value
          }
        }).success(function (r) {
          scope.potentialMembers[i].status_loading = false;
          scope.foundMembers[i].value = value;

          if (r.length === 1) {
            // var [valid, errorMessage] = checkStatusRules(r[0].ExecutiveStatusSortOrder, r[0].CountryId, scope, i);
            var _util$checkStatusRule3 = util.checkStatusRules(r[0], scope, i),
                _util$checkStatusRule4 = _slicedToArray(_util$checkStatusRule3, 2),
                valid = _util$checkStatusRule4[0],
                errorMessage = _util$checkStatusRule4[1];

            if (valid) {
              scope.potentialMembers[i].status_correct = true;
            } else {
              scope.potentialMembers[i].status_error = true;
              scope.potentialMembers[i].errorMessage = errorMessage;
            }

            scope.potentialMembers[i].result_name = r[0].GreetingName;

            if (r[0].ExecutiveStatusDescription) {
              scope.potentialMembers[i].result_status = r[0].ExecutiveStatusDescription;
            } else if (r[0].ExecutiveStatusDescption) {
              scope.potentialMembers[i].result_status = r[0].ExecutiveStatusDescption;
            }

            scope.potentialMembers[i].memberID = r[0].CustomerId;
            scope.potentialMembers[i].result_status_sortOrder = r[0].ExecutiveStatusSortOrder;
          } else {
            scope.potentialMembers[i].status_error = true;
            scope.potentialMembers[i].errorMessage = 'Information not found, try again.';
          }

          util.checkCreateTeamValidation(scope);
        }).error(function (e) {
          scope.potentialMembers[i].status_loading = false;
          scope.potentialMembers[i].status_error = true;

          if (e.length > 50) {
            scope.potentialMembers[i].errorMessage = scope.labels.errorMessages.somethingWentWrong;
          } else {
            scope.potentialMembers[i].errorMessage = e.replace(/"/g, '');
          }
        });
      },
      trueSubmitCreateTeam: function trueSubmitCreateTeam(scope) {
        scope.teamSubmitting = true;
        scope.registrationInProcess = true;
        console.log('the registration initiated..', scope.registrationInProcess);
        var teamLead = {
          MemberID: Number(scope.memberID),
          MemberName: scope.global.name
        };
        var submitData = {
          TeamID: 0,
          Name: "".concat(scope.memberID),
          TeamLead: teamLead,
          EventID: scope.eventID,
          Members: [teamLead]
        };

        if (!scope.showGoals) {
          submitData.EnrollmentGoal = 4;
        } else {
          submitData.EnrollmentGoal = scope.teamGoalInput.value;
        }

        $http.post('/externalservices/api/teams/CreateTeam', JSON.stringify(submitData)).success(function (r) {
          // console.log(r);
          scope.teamSubmissionSuccess = true;
          scope.teamSubmitting = false;
          scope.modals.createTeam = false;
          scope.modalIsOpen = true;
          scope.yOffSet = "calc(10vh + ".concat($window.pageYOffset, "px)"); //console.log('the yoffset', scope.yOffSet);

          scope.modals.success = true;
          scope.teamSubmitted = true;
          scope.teamHasBeenCreated = true;
          $window.scrollTo(0, 0);
          trackAction({
            id: 314
          });
        }).error(function (e) {
          scope.teamSubmitting = false;
          scope.registrationInProcess = false;
          scope.submitError = scope.labels.errorMessages.somethingWentWrong;
          console.error(e);
        });
      },
      trueShareWithTeam: function trueShareWithTeam(scope) {
        var _this2 = this;

        var submitData = {
          TeamSharingID: 0,
          TeamID: scope.team.TeamID,
          MemberCustomerID: "".concat(scope.memberID),
          SharedCustomerID: scope.potentialShareMember.memberID,
          IsDeleted: false
        }; //console.log('data to submit:', JSON.stringify(submitData));

        $http.post('/ExternalServices/Api/Teams/CreateTeamSharingSubscription', JSON.stringify(submitData)).success(function (r) {
          console.log(r);
          scope.modals.shareWithTeam = false;
          scope.modals.shareSuccess = true;
          scope.openModal('shareSuccess');

          _this2.getTeamSharing(submitData.MemberCustomerID, submitData.TeamID, scope);
        }).error(function (e) {
          scope.teamSubmitting = false;
          scope.submitError = scope.labels.errorMessages.somethingWentWrong;
          console.error(e);
        });
      },
      // used for customers who want to be put on a team
      submitPutTeam: function submitPutTeam(scope) {
        scope.teamSubmitting = true;
        var goal = Number(scope.joinGoalInput);
        var teamID = goal == 4 ? 1 : 2;
        var teamName = goal == 4 ? 'Orphan' : 'Expanded Orphan';
        var submitData = {
          TeamID: teamID,
          Name: teamName,
          TeamLead: {
            MemberID: 1,
            MemberName: null
          },
          EnrollmentGoal: goal,
          Members: [{
            MemberID: scope.memberID,
            MemberName: scope.global.name
          }]
        };
        $http.post('/externalservices/api/teams/UpdateTeam', JSON.stringify(submitData)).success(function (r) {
          // console.log(r);
          scope.teamSubmitting = true;
          scope.modals.putMeOnTeam = false;
          scope.modals.success = true;
          scope.teamSubmitted = true;
          scope.youHaveBeenAdded = true;
        }).error(function (e) {
          scope.teamSubmitting = false;
          scope.submitError = scope.labels.errorMessages.somethingWentWrong;
          console.error(e);
        });
      },
      getLeaderboard: function getLeaderboard($scope) {
        $http.get("/ExternalServices/API/Report/GetDynamicData?identifier=TeamEventData_AllTeams".concat($scope.testCustomer, "&parameters[0][key]=EventID&parameters[0][Value]=").concat($scope.eventID)) // .get('https://ezmock.herokuapp.com/api/5e7004300215560015d65fab')
        .success(function processAllTeamData(r) {
          var top10NotReached = true;
          var top20NotReached = true;
          var top100NotReached = true;

          if (r.length) {
            $scope.leaderboard = r.map(function addTeamMembers(obj) {
              return angular.extend({}, obj, {
                Goal: obj.Goal == 4 ? '12point' : '20point'
              }, {
                TeamMembers: [],
                ShowTeamMembers: false
              });
            }).map(function (obj, i) {
              if (i > 0) {
                if (obj.Rank > $scope.topTeamNum && top10NotReached) {
                  obj.top10End = true;
                  top10NotReached = false;
                } else if (obj.Rank > 20 && top20NotReached) {
                  obj.top20End = true;
                  top20NotReached = false;
                } else if (obj.Rank > 100 && top100NotReached) {
                  obj.top100End = true;
                  top100NotReached = false;
                } else if (obj.Rank === null) {
                  obj.Rank = Infinity;
                }
              }

              return obj;
            });
            $scope.numberOfPages = Math.ceil($scope.leaderboard.length / $scope.pageSize);
            $scope.paginationArr = new Array($scope.numberOfPages);
          } else {
            $scope.leaderboard = [1];
          }
        });
      },
      getMyOrgLeaderboard: function getMyOrgLeaderboard(scope) {
        $http.get("/ExternalServices/API/Report/GetDynamicData?identifier=TeamEventData_MyOrgTeams".concat(scope.testCustomer, "&parameters[0][key]=CustomerID&parameters[0][Value]=").concat(scope.customerID, "&parameters[1][key]=EventID&parameters[1][Value]=").concat(scope.eventID)) // .get('https://ezmock.herokuapp.com/api/5e60366f88b91600155f5c76')
        .success(function processOrgTeamData(r) {
          scope.myOrgLeaderboard = r.map(function addTeamMembers(obj) {
            return angular.extend({}, obj, {
              Goal: obj.Goal == 4 ? '12point' : '20point'
            }, {
              TeamMembers: [],
              ShowTeamMembers: false
            });
          });

          if (scope.myOrgLeaderboard.length <= 1) {
            scope.myOrgLeaderboard.done = true;
          }
        });
      },
      // get data for the month view of accountability data
      getAccountabilityMonths: function getAccountabilityMonths(scope, id) {
        $http.get("/ExternalServices/API/Report/GetDynamicData?identifier=TeamEventData_TeamAllAccountabilityData".concat(scope.testCustomer, "&parameters[0][key]=TeamID&parameters[0][Value]=").concat(id)).success(function (r) {
          var months = _.unique(r.map(function (o) {
            return o.Month;
          })).map(function (m) {
            return r.filter(function (o) {
              return o.Month === m;
            });
          });

          scope.accountabilityMonths = months.map(function (m) {
            return _.unique(m.map(function (o) {
              return o.CustomerID;
            }));
          }).map(function (nArr, i) {
            return nArr.map(function (n) {
              return months[i].filter(function (o) {
                return o.CustomerID === n;
              });
            });
          }).map(function (m) {
            return m.map(function (p) {
              p.Name = p[0].Name;
              return p;
            });
          }).map(function (m) {
            return m.map(function (tm) {
              tm.MonthlyTotals = tm.reduce(function (a, c) {
                return {
                  Contacts: a.Contacts + c.Contacts,
                  Appointments: a.Appointments + c.Appointments,
                  Overviews: a.Overviews + c.Overviews
                };
              }, {
                Contacts: 0,
                Appointments: 0,
                Overviews: 0
              });
              return tm;
            });
          }).map(function (arr) {
            // sort name alphabetically
            arr.sort(function (a, b) {
              return a[0].Name.localeCompare(b[0].Name, 'en', {
                sensitivity: 'base'
              });
            });
            return arr;
          }).map(function (arr) {
            // grab the first arrays first index and get the month value
            arr.Month = scope.labels.months[arr[0][0].Month];
            arr.Slots = new Array(31).fill(1);
            arr.Days = arr.Slots.map(function (a, i) {
              if (arr[0][i]) {
                return i + 1;
              } else {
                return '';
              }
            });
            arr.MonthlyTotals = arr.reduce(function (a, c) {
              return {
                Contacts: a.Contacts + c.MonthlyTotals.Contacts,
                Appointments: a.Appointments + c.MonthlyTotals.Appointments,
                Overviews: a.Overviews + c.MonthlyTotals.Overviews
              };
            }, {
              Contacts: 0,
              Appointments: 0,
              Overviews: 0
            });
            return arr;
          }).map(function (m, i, arr) {
            m.DailyTotals = m[0].reduce(function (acc, cur, j) {
              return acc.concat({
                Contacts: addValues('Contacts', arr[i], j),
                Appointments: addValues('Appointments', arr[i], j),
                Overviews: addValues('Overviews', arr[i], j)
              });
            }, []);
            return m;
          }).reverse();
          console.log(months, scope.accountabilityMonths);
        });

        function addValues(prop, array, index) {
          return array.map(function (m) {
            return m.filter(function (o, i) {
              return i === index;
            });
          }).reduce(function (a, c) {
            return a.concat(c);
          }).reduce(function (a, c) {
            return a + c[prop];
          }, 0);
        }
      },
      // get accountability for 7 day view
      getAccountabilityTeam: function getAccountabilityTeam(id, scope) {
        $http.get("/ExternalServices/API/Report/GetDynamicData?identifier=TeamEventData_Team7DayAccountabilityData".concat(scope.testCustomer, "&parameters[0][Key]=TeamID&parameters[0][Value]=").concat(id)).success(function (r) {
          // get array of team member ids for sorting
          var teamIDs = scope.myTeam.teamMembers.map(function (a) {
            return a.ID;
          }); // get array of customer IDs

          scope.teamAccountabilityData = _.unique(r.map(function (o) {
            return o.CustomerID;
          })) // replace ids with array of objects for that name
          .map(function (id) {
            return r.filter(function (o) {
              return o.CustomerID === id;
            });
          }).map(function (tm) {
            return tm.sort(function (a, b) {
              var _a = new Date(a.Date).valueOf();

              var _b = new Date(b.Date).valueOf();

              return _b - _a;
            });
          }) // sort Team based on team table
          .sort(function (a, b) {
            return teamIDs.indexOf(a[0].CustomerID) - teamIDs.indexOf(b[0].CustomerID);
          }).map(function (tm) {
            return tm.reverse();
          }).map(function (tm) {
            return tm.map(function (obj) {
              var temp = angular.extend({}, obj, {
                Date: util.formatDate(obj.Date, scope),
                CustomerPhone: util.formatPhoneNumber(obj.CustomerPhone)
              });
              temp.DisplayDate = util.formatTheDateToDisplay(temp.Date, scope);
              return temp;
            });
          }).map(function (tm) {
            return tm.map(function (obj) {
              return angular.extend({}, obj, {
                TrackContact: 'ContactsGoal' + '_' + obj.CustomerID + '_' + obj.Date.replace(/\//g, ''),
                TrackAppointment: 'AppointmentsGoal' + '_' + obj.CustomerID + '_' + obj.Date.replace(/\//g, ''),
                TrackOverview: 'OverviewsGoal' + '_' + obj.CustomerID + '_' + obj.Date.replace(/\//g, '')
              });
            });
          }).sort(function (a, b) {
            return a[0].CustomerName.charCodeAt(0) - b[0].CustomerName.charCodeAt(0);
          }); // console.log('teamAccountabilityData',scope.teamAccountabilityData);

          scope.teamMember = scope.teamAccountabilityData.reduce(function (acc, cur) {
            return acc.concat(cur);
          }, []).reduce(function (acc, cur) {
            acc[cur.TrackContact] = cur.Contacts;
            acc[cur.TrackAppointment] = cur.Appointments;
            acc[cur.TrackOverview] = cur.Overviews; // console.log('cur:', cur);

            return acc;
          }, {});
        }).error(function (e) {
          console.log(e);
        });
      },
      getLeaderboardTeamMemberInfo: function getLeaderboardTeamMemberInfo(id, scope, list) {
        $http.get("/ExternalServices/API/Report/GetDynamicData?identifier=TeamEventData_TeamData".concat(scope.testCustomer, "&parameters[0][Key]=TeamID&parameters[0][Value]=").concat(id)).success(function (r) {
          var leaderTeam = util.createTeamWithData(r, scope);
          var temp = scope[list].map(function (tm) {
            if (tm.TeamID == id) {
              tm.TeamMembers = leaderTeam.teamMembers;
              tm.ShowTeamMembers = true;
              return tm;
            } else {
              return tm;
            }
          });
          $timeout(function () {
            scope[list] = temp;
          }); // console.log(id, scope.leaderboard);
          // console.log('myTeam',scope.myTeam);
        });
      },
      updateTeamSharingSubscriptions: function updateTeamSharingSubscriptions(submitData, scope) {
        // console.log('the updated list', submitData);
        var that = this;
        scope.updateInProcess = true;
        $http.post('/ExternalServices/Api/Teams/UpdateTeamSharingSubscriptions', JSON.stringify(submitData)).success(function () {
          $timeout(function () {
            that.getTeamSharing(scope.memberID, scope.team.TeamID, scope);
            scope.openModal('updateSuccess');
            scope.selectedToUnShare = true;
            scope.updateInProcess = false;
          });
        }).error(function (e) {
          console.log(e);
          scope.updateInProcess = false;
        });
      },
      setAccountabilityTeam: function setAccountabilityTeam(submitData, scope) {
        //console.log(JSON.stringify(submitData));
        var that = this;
        $http.post('/ExternalServices/API/Teams/SetTeamAccountability', JSON.stringify(submitData)).success(function () {
          $timeout(function () {
            scope.teamAccountabilitySubmitting = false;
            that.getAccountabilityTeam(scope.myTeam.teamInfo.ID, scope);
            that.getTeamInfo(scope.team.TeamID, scope);
          });
        }).error(function (e) {
          console.log(e);
          scope.teamAccountabilitySubmitting = false;
        });
      },
      playVideo: function playVideo(event, mediaItemName) {
        event.preventDefault();
        $http({
          method: 'GET',
          url: '/ExternalServices/Api/Media/?mediaItemName=' + mediaItemName
        }).then(function (data) {
          if (firstload) {
            $('body').prepend('<style type="text/css">#mediaPlayer{margin:0 auto;display: inline-block;}</style>');
            firstload = false;
          }

          var videoheight = 360,
              videowidth = 640,
              melaPlayer = new MelaVideoPlayer('mediaContainer', 'mediaPlayer', videoheight, videowidth, 'fast track videos');
          $('body').prepend('<div class="mediaContainer" id="mediaContainer" style="background: rgba(0,0,0,.5); height: 100%; position: absolute; width: 100%; z-index: 999;"><div class="close-wrapper" style="height: 100%; left: 0; position: absolute; top: 0; width: 100%;"></div><div class="close-button-wrapper" style="padding-left: 336px; position: absolute; text-align: center; width: 100%;"><i class="close-button fa fa-times-circle" style="color: #fff; cursor: pointer; font-size: 24px;"></i></div><div class="mediaPlayer" id="mediaPlayer"></div></div>');
          var currWinHeight = parseInt(($(window).height() - videoheight) / 2 + $(document).scrollTop()),
              windowHeightis = String(currWinHeight) + 'px',
              setwindowHeight = $(document).height() - currWinHeight,
              // setup player
          videoSetup = {
            Video: data.data,
            PreventSeeking: false,
            // ShowCustomProgressBar : true,
            Autostart: true,
            // This should almost never be done
            ScrollToTop: false,
            RecordingInterval: 10,
            CanResumePlay: true,
            FeatureID: 2
          }; // position player

          $('.mediaContainer').css('height', setwindowHeight + 'px');
          $('.mediaContainer').css('padding-top', windowHeightis);

          try {
            var melavideo = melaPlayer.SetupVideo(videoSetup);
          } catch (e) {
            console.log('video not found', e);
            var globaldropdown = $('#globalCountryDropdownMobile').find(':selected').val().toLowerCase();
            var wmculture = globaldropdown.substring(0, 2) === 'zh' ? globaldropdown.substring(3, 5) : globaldropdown.substring(0, 2);
            var errorLocalization = {
              cn: '该视频或音频暂时无法播放，对此造成的任何不便，我们深表歉意。',
              de: 'Die von Ihnen ausgewählte Video- oder Audiodatei ist derzeit nicht verfügbar. Wir entschuldigen uns für etwaige Unannehmlichkeiten.',
              en: 'The video or audio you selected is currently not available. Sorry for any inconvenience this may cause.',
              es: 'El archivo de video o de audio que seleccionó no está disponible en este momento. Lamentamos este inconveniente.',
              fr: "La vidéo ou l'audio que vous avez sélectionné n'est actuellement pas disponible. Désolé pour tout inconvénient que cela peut causer.",
              hk: '您目前點選的影片暫時無法播放，造成不便請見諒。',
              ja: '選択された動画は現在ご利用できません。ご不便おかけし申し訳ありません。',
              ko: '선택하신 비디오 또는 오디오는 현재 사용할 수 없습니다. 불편을 끼쳐 드려 죄송합니다.',
              my: '您所点选的影音档案暂时无法播放，造成任何不便敬请见谅。',
              nl: 'De video of audio die u hebt geselecteerd, is momenteel niet beschikbaar. Onze excuses voor het eventuele ongemak.',
              pl: 'Wybrane wideo lub fonia jest obecnie niedostępne. Przepraszamy za wszelkie niedogodności z tym związane.',
              sg: '您所点选的影音档案暂时无法播放，造成任何不便敬请见谅。',
              tw: '您目前點選的影音檔無法播放，造成不便請見諒。'
            };
            var localCopy = errorLocalization[wmculture] || errorLocalization['en'];
            var videounavailable = '<p class="p" style="color: #000;font-size: 20px;line-height: 30px;width: 530px;background-color: #fff;padding: 40px;border-radius: 10px;">' + localCopy + '</p>';
            $('#mediaPlayer').html(videounavailable);
          } // create listener to close video player


          $('.close-wrapper, .close-button').on('click', function () {
            try {
              jwplayer().stop();
              $('.mediaContainer').hide();
              removePlayer();
            } catch (e) {
              console.log('Player not present', e);
              $('.mediaContainer').remove();
            }
          });
        });
      }
    };
  }

  angular.module('fasttrack').factory('util', ['$window', '$injector', '$timeout', '$document', utilFactory]);

  function utilFactory($window, $injector, $timeout, $document) {
    var _ref;

    return _ref = {
      seeMain: function seeMain(scope) {
        scope.currentView = scope.mainView;

        if (scope.teamLeader) {
          var ext = $injector.get('ext');
          ext.getAccountabilityTeam(scope.myTeam.teamInfo.ID, scope);
        }
      },
      myOrgTab: function myOrgTab(scope) {
        this.setTabActive('tabMyOrgActive', scope);

        if (scope.myOrgLeaderboard.length === 0) {
          var ext = $injector.get('ext');
          ext.getMyOrgLeaderboard(scope);
        }
      },
      setTabActive: function setTabActive(tabname, scope) {
        scope.tabLeaderBoardActive = false;
        scope.tabMyTeamActive = false;
        scope.tabMyOrgActive = false;
        scope.tabMyActivityActive = false;
        scope[tabname] = true;
      },
      adjustCulture: function adjustCulture(culture) {
        return culture.replace(/-/, '').toLowerCase();
      },
      createTeamWithData: function createTeamWithData(arr, scope) {
        var _this = this;

        var ti = arr.filter(function (o) {
          return o.RowType === 'Team';
        }).reduce(function (a, c) {
          return c;
        });
        ti.GoalIcon = ti.Goal == 4 ? '12point' : '20point';
        ti.ShowTeamMembers = false;
        var tm = arr.filter(function (o) {
          return o.RowType === 'TeamMember';
        }).map(function (o) {
          return angular.extend({}, o, {
            PhoneNumber: _this.formatPhoneNumber(o.PhoneNumber)
          });
        }).sort(function (a, b) {
          return b.Points_Tot - a.Points_Tot;
        }); // if (tm.length < 4) {
        //   // add missing team member to display on team table
        //   var i = 0;
        //   var length = 4 - tm.length;
        //   for (i; i < length; i++) {
        //     tm.push({
        //       Partial: true,
        //       Name: scope.labels.partialTeam,
        //       Points_Tot: "-",
        //       Contacts_MTD: "-",
        //       Contacts_Tot: "-",
        //       Appointments_MTD: "-",
        //       Appointments_Tot: "-",
        //       Overviews_MTD: "-",
        //       Overview_Tot: "-"
        //     });
        //   }
        // }

        return {
          teamInfo: ti,
          teamMembers: tm
        };
      },
      checkChange: function checkChange(val, arr, key) {
        // if the val and the val in the arr do not match return true meaning
        // it has been edited
        var temp = arr.filter(function (obj) {
          return obj.id == key;
        });

        if (temp.length) {
          return temp.reduce(function (acc, cur) {
            return cur.val != val && acc;
          }, true);
        }

        return false;
      },
      enableUpdate: function enableUpdate(scope) {
        console.log('enabling update...');

        if (scope.mySharingList.some(function (shared) {
          return !shared.selected;
        })) {
          scope.selectedToUnShare = false;
        } else {
          scope.selectedToUnShare = true;
        }
      },
      gatherSharing: function gatherSharing(e, scope) {
        var selectedToDelete = []; // scope.mySharingList.forEach(function (shared) {
        //   if (!shared.selected) {
        //     selectedToDelete.push(shared);
        //   }
        // });
        // scope.mySharingList.forEach((el) => {
        //   selectedToDelete.forEach((e) => {
        //     if (e.SharedCustomerID === el.SharedCustomerID) {
        //       el.IsDeleted = true;
        //     }
        //   });
        // });

        selectedToDelete = scope.mySharingList.reduce(function (acc, curr) {
          if (!curr.selected) {
            curr.IsDeleted = true;
            acc.push(curr);
          }

          return acc;
        }, []);
        console.log('the members selected to delete', selectedToDelete);
        var ext = $injector.get('ext');
        ext.updateTeamSharingSubscriptions(selectedToDelete, scope);
      },
      gatherAccountability: function gatherAccountability(e, scope) {
        scope.teamAccountabilitySubmitting = true;
        e.preventDefault(); // get array of edited values from teamMember object

        var vals = [];
        var arrayToCheckAgainst = scope.teamAccountabilityData.reduce(function (acc, cur) {
          return acc.concat(cur);
        }, []).reduce(function (acc, cur) {
          return acc.concat([{
            id: cur.TrackAppointment,
            val: cur.Appointments
          }, {
            id: cur.TrackContact,
            val: cur.Contacts
          }, {
            id: cur.TrackOverview,
            val: cur.Overviews
          }]);
        }, []);

        for (var key in scope.teamMember) {
          if (this.checkChange(scope.teamMember[key], arrayToCheckAgainst, key)) {
            vals.push(key);
          }
        } // group edited inputs by member


        var regID = new RegExp(/\w+_(\d+)_\d+/);
        var regDate = new RegExp(/\w+_\d+_(\d+)/);
        var regVal = new RegExp(/(\w+)(_\d+_\d+)/);

        var members = _.unique(vals.map(function (s) {
          return s.replace(regID, '$1');
        })).map(function (number) {
          return vals.filter(function (key) {
            var reg = new RegExp(number);
            return reg.test(key);
          });
        }) // remove entries with the same date
        .map(function (arr) {
          return _.unique(arr, function (o) {
            return o.replace(regDate, '$1');
          });
        }) // change each team member array into object with an array
        // objects containing values for submitting
        .map(function (arr) {
          return {
            CustomerId: arr[0].replace(regID, '$1'),
            TeamGoals: arr.map(function (s) {
              var cSelect = '#' + s.replace(regVal, 'ContactsGoal$2');
              var cVal = $(cSelect).val();
              var aSelect = '#' + s.replace(regVal, 'AppointmentsGoal$2');
              var aVal = $(aSelect).val();
              var oSelect = '#' + s.replace(regVal, 'OverviewsGoal$2');
              var oVal = $(oSelect).val();
              var date = s.replace(regDate, '$1').replace(/(\d{2})(\d{2})(\d{2})/, '20$3-$1-$2T00:00:00-07:00'); // give back time since epoch

              var d = new Date(date).valueOf();
              return {
                GoalDate: "/Date(".concat(d, ")/"),
                ContactsGoal: null,
                AppointmentsGoal: aVal ? aVal : null,
                OverviewsGoal: oVal ? oVal : null,
                NamesGoal: cVal ? cVal : null //New parameter added for internation fasttrack-@anud

              };
            })
          };
        });

        var ext = $injector.get('ext');
        console.log('the members array', members);
        ext.setAccountabilityTeam(members, scope);
        console.log('members', members);
      },
      seeMnthlyAcct: function seeMnthlyAcct(id, teamName, scope) {
        scope.accountabilityViewTeamName = teamName;
        console.log('the monthly cal:', id, teamName);

        if (id) {
          var ext = $injector.get('ext');
          ext.getAccountabilityMonths(scope, id);
        } // change the view


        scope.currentView = scope.accountabilityView;
      },
      captureReturn: function captureReturn(e, value, scope) {
        // console.log(e.keyCode);
        // console.log('the value', value);
        if (e.keyCode === 13) {
          e.preventDefault(); // this.searchForTeamMember(value, i, scope);

          this.searchForTeamMemberToShare(value, scope);
        }
      },
      showMoreTeam: function showMoreTeam(event, id, list, scope) {
        $(event.target).closest('tr').toggleClass('is-active');
        var tempTeam = scope[list].filter(function (obj) {
          return obj.TeamID == id;
        })[0];
        var showTeam = tempTeam.ShowTeamMembers;

        if (showTeam === false) {
          if (tempTeam.TeamMembers.length === 0) {
            var ext = $injector.get('ext');
            ext.getLeaderboardTeamMemberInfo(id, scope, list);
          }
        }

        tempTeam.ShowTeamMembers = tempTeam.ShowTeamMembers ? false : true;
        $timeout(function () {
          scope[list].map(function (obj) {
            if (obj.TeamID == id) {
              return tempTeam;
            } else {
              return obj;
            }
          });
        });
      },
      resetInput: function resetInput(event, scope) {
        if (event.keyCode === 8 && scope.potentialShareMember.value === '') {
          this.clearObject(scope.potentialShareMember); // this.checkCreateTeamValidation(scope);
        }
      },
      getEventID: function getEventID() {
        if (/^web/i.test(location.hostname)) {
          var environment = location.hostname.match(/web(\w{2})/i)[1];
          return $window.ftg.eventID[environment];
        } else if (/^(qa|ua|st)/i.test(location.hostname)) {
          var _environment = location.hostname.match(/^(\w{2})/i)[1];
          return $window.ftg.eventID[_environment];
        }

        return $window.ftg.eventID.production;
      },
      closeModalInModal: function closeModalInModal(scope) {
        scope.teamNotFull = false;
      },
      submitCreateTeam: function submitCreateTeam(scope) {
        // var teamMembersAmount = scope.potentialMembers.filter(a => a.value)
        //   .length;
        // if (teamMembersAmount < 3) {
        //   scope.teamNotFull = true;
        // } else {
        var ext = $injector.get('ext');
        ext.trueSubmitCreateTeam(scope); // }
      },
      shareWithTeam: function shareWithTeam(scope) {
        var numberOfMembers = scope.mySharingList.length;

        if (numberOfMembers >= 10) {
          scope.closeModal('shareWithTeam');
          scope.openModal('alert');
          return;
        }

        var ext = $injector.get('ext');
        ext.trueShareWithTeam(scope);
        this.clearObject(scope.potentialShareMember);
      },
      showMore: function showMore(scope) {
        scope.rowSize = scope.rowSize + 10;
      },
      openModal: function openModal(modal, scope) {
        scope.modalIsOpen = true;
        scope.yOffSet = "calc(10vh + ".concat($window.pageYOffset, "px)"); //console.log('the yoffset', scope.yOffSet);

        scope.modals[modal] = true;
        if (modal === 'openModal') trackAction({
          id: 312
        });
      },
      closeModal: function closeModal(scope) {
        scope.modalIsOpen = false;
        scope.submitError = '';

        for (var m in scope.modals) {
          if (m === 'shareWithTeam') {
            scope.searchingForEnroller = false;
            scope.shareWithMyEnroller.selected = false;
          }

          scope.modals[m] = false;
        }
      },
      clearInput: function clearInput(event, scope) {
        // event.preventDefault();
        this.clearObject(scope.potentialShareMember); // this.checkCreateTeamValidation(scope);
      },
      sortTheTable: function sortTheTable(sortOrder, scope) {
        console.log('the sort by:', sortOrder);

        if (sortOrder === 'total') {
          scope.allActivityDetail.sort(function (a, b) {
            return (b.Enrollments.Total ? b.Enrollments.Total : 0) - (a.Enrollments.Total ? a.Enrollments.Total : 0);
          });
        } else if (sortOrder === 'enrollments') {
          scope.allActivityDetail.sort(function (a, b) {
            return (b.Enrollments.QualityTotalActivity ? b.Enrollments.QualityTotalActivity : 0) - (a.Enrollments.QualityTotalActivity ? a.Enrollments.QualityTotalActivity : 0);
          });
        } else if (sortOrder === 'leadership') {
          scope.allActivityDetail.sort(function (a, b) {
            return (b.Leadership.QualityTotalActivity ? b.Leadership.QualityTotalActivity : 0) - (a.Leadership.QualityTotalActivity ? a.Leadership.QualityTotalActivity : 0);
          });
        } else if (sortOrder === 'alphabatical') {
          // console.log('sorting now alpahb....');
          scope.allActivityDetail.sort(function (a, b) {
            return a.Enrollments.SharedCustomerName < b.Enrollments.SharedCustomerName ? -1 : a.Enrollments.SharedCustomerName > b.Enrollments.SharedCustomerName ? 1 : 0;
          });
        }
      },
      searchForTeamMember: function searchForTeamMember(value, i, scope) {
        // check to make sure number in input hasn't already been approved so
        // numbers that have been accepted and are in input aren't searched
        // again
        if (scope.potentialMembers[i].value != scope.foundMembers[i].value) {
          // clear any status indications
          this.clearStatus(scope.potentialMembers[i], scope);

          if (value && value.length > 2) {
            var ext = $injector.get('ext');
            ext.searchForTeamMember(value, i, scope);
          }

          if (value === undefined) {
            this.clearObject(scope.potentialMembers[i]);
          }
        }
      },
      searchForTeamMemberToShare: function searchForTeamMemberToShare(value, scope) {
        if (value) {
          var ext = $injector.get('ext');
          ext.searchForTeamMemberToShare(value, scope);
        }

        if (value === undefined) {
          console.log('value is undefined');
          this.clearObject(scope.potentialShareMember);
        }
      },
      checkAndShareWithMyEnroller: function checkAndShareWithMyEnroller(enrollerPhNumber, scope) {
        console.log('the enroller check selected:', scope.shareWithMyEnroller.selected);

        if (scope.shareWithMyEnroller.selected) {
          scope.searchingForEnroller = !scope.searchingForEnroller;
          this.searchForTeamMemberToShare(enrollerPhNumber, scope);
        } else {
          this.clearObject(scope.potentialShareMember);
          scope.searchingForEnroller = false;
        }
      },
      checkForEnrollerInList: function checkForEnrollerInList(scope) {
        if (scope.mySharingList.some(function (v) {
          return v.SharedCustomerID === scope.enrollerCustId;
        })) {
          scope.enrollerInList = true; //to hide the checkbox

          scope.searchingForEnroller = false; //to show the serach input back

          console.log('the enroller already in the list');
        } else {
          scope.enrollerInList = false; //show the checkbox again
          //scope.searchingForEnroller = true;

          scope.shareWithMyEnroller.selected = false; //make the checkbox unselected again

          this.clearObject(scope.potentialShareMember);
        }

        scope.openModal('shareWithTeam');
      },
      formatPhoneNumber: function formatPhoneNumber(number) {
        if (number) {
          return number.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
        } else {
          return '-';
        }
      }
    }, _defineProperty(_ref, "formatPhoneNumber", function formatPhoneNumber(number) {
      if (number) {
        return number.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
      } else {
        return '-';
      }
    }), _defineProperty(_ref, "formatTheDateToDisplay", function formatTheDateToDisplay(_date, scope) {
      var _date$match = _date.match(/(\d{1,2})\/(\d{1,2})\/(\d{2})/),
          _date$match2 = _slicedToArray(_date$match, 4),
          ignore = _date$match2[0],
          m = _date$match2[1],
          d = _date$match2[2],
          y = _date$match2[3];

      m = m.replace(/^0/, '');
      d = d.replace(/^0/, '');

      if (scope.dateFormatConfig) {
        return scope.dateFormatConfig.replace('y', y).replace('m', m).replace('d', d);
      } else {
        // do it the default way
        return _date;
      }
    }), _defineProperty(_ref, "formatDate", function formatDate(date, scope) {
      var _date$match3 = date.match(/(\d{4})-(\d{2})-(\d{2})/),
          _date$match4 = _slicedToArray(_date$match3, 4),
          ignore = _date$match4[0],
          year = _date$match4[1],
          month = _date$match4[2],
          day = _date$match4[3];

      var dd = new Date(year, Number(month) - 1, day);

      var _date = dd.getMonth() + 1 + '/' + dd.getDate() + '/' + dd.getFullYear().toString().match(/\d{2}$/)[0];

      return _date.split('/').map(function (n) {
        return paddNumber(n);
      }).join('/');

      function paddNumber(n) {
        if (n.length < 2) {
          return '0' + n;
        } else {
          return n;
        }
      }
    }), _defineProperty(_ref, "clearStatus", function clearStatus(obj, scope) {
      for (var v in obj) {
        if (/^status_/.test(v)) {
          $timeout(function () {
            return obj[v] = '';
          });
        }
      }
    }), _defineProperty(_ref, "clearObject", function clearObject(obj) {
      for (var v in obj) {
        if (obj.hasOwnProperty(v)) {
          obj[v] = '';
        }
      }
    }), _defineProperty(_ref, "checkCreateTeamValidation", function checkCreateTeamValidation(scope) {
      console.log('checking validation');
      $timeout(function () {
        var teamInputsCorrect = scope.potentialMembers.some(function (obj) {
          return obj.status_correct;
        });
        var teamInputsError = scope.potentialMembers.some(function (obj) {
          return obj.status_error;
        });
        var teamLength = scope.potentialMembers.filter(function (obj) {
          return obj.value;
        }).length;

        if (teamInputsError) {
          scope.createTeamInvalid = true;
        } else {
          scope.createTeamInvalid = !(teamInputsCorrect && teamLength >= scope.global.minimumMembers && scope.teamGoalInput.value && scope.createTeamCheckbox);
          console.log('createTeamInvalid', scope.createTeamInvalid);
        }
      });
    }), _defineProperty(_ref, "checkStatusRules", function checkStatusRules(potentialMmbr, scope) {
      if (scope.mySharingList.some(function (v) {
        return v.MemberCustomerID === potentialMmbr.CustomerId || v.SharedCustomerID === potentialMmbr.CustomerId;
      })) {
        console.log('repeat');
        return [false, scope.labels.errorMessages.duplicateTeamMember];
      } // team member is valid


      return [true, ''];
    }), _defineProperty(_ref, "scrollToTabs", function scrollToTabs() {
      var temp = $document[0].getElementById('tabs');
      temp.scrollIntoView();
    }), _ref;
  }

  angular.module('fasttrack').filter('trustAsHtml', ['$sce', trustHtml]);

  function trustHtml($sce) {
    return function (value) {
      return $sce.trustAsHtml(value);
    };
  }

  angular.module('fasttrack').filter('startFrom', start);

  function start() {
    return function (input, start) {
      return input.slice(start);
    };
  }

  angular.module('fasttrack').directive('track', trackFunction);

  function trackFunction() {
    return {
      restrict: 'A',
      scope: {
        track: '@track'
      },
      link: function link(scope, element, attrs) {
        element.on('click', function (e) {
          e.stopPropagation();

          var _attrs$track$match = attrs.track.match(/(\d+),?(.*)?/),
              _attrs$track$match2 = _slicedToArray(_attrs$track$match, 3),
              ignore = _attrs$track$match2[0],
              id = _attrs$track$match2[1],
              eL = _attrs$track$match2[2]; // console.log({ id, eL: removeHtmlTags(eL) });


          if (eL) {
            eL = removeHtmlTags(eL);
            trackAction({
              id: id,
              eL: eL
            });
          } else {
            trackAction({
              id: id
            });
          }
        });
      }
    };
  }

  function removeHtmlTags(string) {
    return string.replace(/<[A-z 0-9='";:.,-\/]+>/gi, '');
  }

  /* global angular, cmCreateElementTag, $, _, standardElementAnalyticsAttributes */

  (function () {
    angular.bootstrap($(document)[0].getElementById('fasttrack'), ['fasttrack']);
  })();

}());
